import PatientOverviewKnowledgeSelection from 'dashboard/templates/views/Patient/Knowledge/PatientOverviewKnowledgeSelection';

export default {
  path: 'selection',
  name: 'PatientRecordKnowledgeSelection',
  component: PatientOverviewKnowledgeSelection,
  meta: {
    // title: 'Patient Record - Knowledge - Selection',
    // title: t => `${t('patient.patientRecord')} - ${t('nutritionBarriers.knowledgeAnswer', 'questionnaires')} - ${t('knowledge.selection')}`,
    // title: 'Increase your Knowledge - Selection',
    title: t => `${t('screens.increaseYourKnowledgeSettingScreen', 'app_mobile')} - ${t('knowledge.selection')}`,
    loggedInOnly: true,
    inSDMSessionOnly: true,
  }
};
